import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useLatestPsaResult = (patientId, { enabled = true } = {}) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["latestPsaResult", patientId, tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const { data } = await axiosInstance.get(
        `${tenantVal}/healthlink/laboratory/latestpsaresult/${patientId}`
      );

      // 204 No Content (no PSA results on file) yields an empty body.
      return data || null;
    },
    enabled: !!enabled && !!patientId && !!tenantVal,
  });
};
